import React, { useEffect } from 'react';
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import TextEditor from '../TextEditor';
import { toast } from 'react-toastify';

function SupportForm({ handleSuccess, handleCancel }) {
  const { register, handleSubmit, errors, control, setError } = useForm();
  let [editorState, setEditorState] = useState('');
  const [categories, setCategories] = useState([]);
  const handleChange = (e) => {
    setEditorState(e);
  };

  const createTicket = async (data) => {
    const formData = new FormData();
    formData.append('title', data.title);
    formData.append('description', data.question);
    formData.append('category', data.category);
    if (data.attachments) {
      for (let i = 0; i < data.attachments.length; i++) {
        formData.append('attachments', data.attachments[i]);
      }
    }
    const server = process.env.REACT_APP_SUPPORT_SERVER_URL;
    const token = localStorage.getItem('token');
    const apiKey = process.env.REACT_APP_SUPPORT_API_KEY;

    await fetch(`${server}/api/v1/support/tickets/`, {
      method: 'POST',
      headers: {
        Authorization: `JWT ${token}`,
        ApiKey: `Token ${apiKey}`,
      },
      body: formData,
    })
      .then((res) => {
        handleSuccess();
      })
      .catch((err) => {
        toast.error('Something went wrong!');
      });
  };

  const handleDiscussion = (data) => {
    if (editorState === '') {
      setError('description', 'required', 'Field is required');
    } else {
      data.question = editorState;
      createTicket(data);
    }
  };
  let optionType = {
    required: 'This field is required.',
    maxLength: {
      value: 200,
      message: 'Field should not be at more than 200 characters.',
    },
  };

  const getCategories = async () => {
    const server = process.env.REACT_APP_SUPPORT_SERVER_URL;
    const token = localStorage.getItem('token');
    const apiKey = process.env.REACT_APP_SUPPORT_API_KEY;

    await fetch(`${server}/api/v1/support/tickets/get_categories/`, {
      method: 'GET',
      headers: {
        Authorization: `JWT ${token}`,
        ApiKey: `Token ${apiKey}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setCategories(data);
      })
      .catch((err) => {
        toast.error('Something went wrong!');
      });
  };

  useEffect(() => {
    getCategories();
  }, []);

  return (
    <form className="q-form m-2" onSubmit={handleSubmit(handleDiscussion)}>
      <div className="form-row">
        <div className="form-group col-12 ">
          <label htmlFor="title">Title</label>
          <input ref={register(optionType)} type="text" name="title" className="form-control" id="textnam3e" />
          <div className="text-danger ml-2 small">{errors.title && errors.title.message}</div>
        </div>
        <div className="form-group col-12">
          <label htmlFor="category">Choose a Category</label>
          <Controller
            as={
              <select name="category" className="form-control custom-select">
                <option>This ticket is related with ...</option>
                {categories.map((c) => (
                  <option value={c.id} key={c.id}>
                    {c.name}
                  </option>
                ))}
              </select>
            }
            name="category"
            rules={{ required: 'Select any category.' }}
            control={control}
          />
          <div className="text-danger ml-2 small">{errors.category && errors.category.message}</div>
        </div>
        <div className="form-group col-12">
          <label htmlFor="description">Description</label>
          <TextEditor editorState={editorState} handleChange={handleChange} register={register(optionType)} />
          <div className="text-danger ml-2 small">{errors.description && errors.description.message}</div>
        </div>
        <div className="form-group col-12">
          <label htmlFor="attachments">Attach a file</label>
          <input
            ref={register}
            multiple
            type="file"
            name="attachments"
            className="form-control-file"
            id="attachments"
          />
          <small className="text-muted">You can attach a file if you want.</small>
        </div>
      </div>
      <div className="d-flex justify-content-end">
        <button type="button" className="btn btn-light mr-2" onClick={() => handleCancel()}>
          Cancel
        </button>
        <button type="submit" className="btn btn-dark">
          Create
        </button>
      </div>
    </form>
  );
}

export default SupportForm;
